import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Quote, Heart } from 'lucide-react';
import { donationApi } from '../services/api';

// Fallback sample dua (shown only if there are no real verified messages yet)
const FALLBACK_DUA = [
  { name: 'Penyumbang', message: 'Semoga Allah memberkati usaha ini dan memudahkan pembinaan KDU. Ameen.', amount: 0, time: '', anonymous: true },
  { name: 'Penyumbang', message: 'Moga menjadi amal jariah yang berkekalan untuk kita semua.', amount: 0, time: '', anonymous: true },
  { name: 'Penyumbang', message: 'Semoga sekolah ini melahirkan generasi daie yang cemerlang dunia akhirat.', amount: 0, time: '', anonymous: true },
];

const WallOfDua = () => {
  const [messages, setMessages] = useState([]);
  const [isFallback, setIsFallback] = useState(false);

  useEffect(() => {
    donationApi.messages()
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          setMessages(data);
          setIsFallback(false);
        } else {
          setMessages(FALLBACK_DUA);
          setIsFallback(true);
        }
      })
      .catch(() => {
        setMessages(FALLBACK_DUA);
        setIsFallback(true);
      });
  }, []);

  if (messages.length === 0) return null;

  return (
    <section className="py-32 bg-gradient-to-b from-purple-50/50 to-white relative overflow-hidden" data-testid="wall-of-dua-section">
      {/* Decorative */}
      <div className="absolute top-10 left-1/2 -translate-x-1/2 opacity-[0.04]">
        <Quote className="w-96 h-96 text-purple-900" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-purple-100 text-purple-700 rounded-full text-sm font-semibold mb-6">
            <Heart className="w-4 h-4 fill-purple-700" />
            Dinding Doa
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Doa & Harapan Penyumbang
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {isFallback
              ? 'Jadilah antara yang pertama meninggalkan doa bersama infaq anda'
              : 'Kata-kata semangat dan doa daripada mereka yang telah berinfaq untuk KDU'}
          </p>
        </motion.div>

        {/* Masonry-ish grid of dua cards */}
        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 max-w-6xl mx-auto space-y-6">
          {messages.map((dua, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-30px' }}
              transition={{ duration: 0.5, delay: (index % 3) * 0.1 }}
              className="break-inside-avoid bg-white rounded-3xl p-7 shadow-lg border border-purple-100 hover:shadow-xl hover:border-purple-200 transition-all"
              data-testid={`dua-card-${index}`}
            >
              <Quote className="w-8 h-8 text-purple-300 mb-4" />
              <p className="text-gray-700 text-lg leading-relaxed mb-5 italic">
                "{dua.message}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-sm">
                    {(dua.name || 'P').charAt(0).toUpperCase()}
                  </span>
                </div>
                <div className="min-w-0">
                  <div className="font-semibold text-gray-900 truncate">{dua.name}</div>
                  {dua.time && <div className="text-xs text-gray-400">{dua.time}</div>}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WallOfDua;
